
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1mxy7_5",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1mxy7_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1mxy7_27",
  "icon": "awsui_icon_gwq0h_1mxy7_41",
  "root": "awsui_root_gwq0h_1mxy7_55",
  "expanded": "awsui_expanded_gwq0h_1mxy7_72",
  "icon-container": "awsui_icon-container_gwq0h_1mxy7_76",
  "trigger": "awsui_trigger_gwq0h_1mxy7_27",
  "trigger-default": "awsui_trigger-default_gwq0h_1mxy7_91",
  "trigger-footer": "awsui_trigger-footer_gwq0h_1mxy7_94",
  "trigger-navigation": "awsui_trigger-navigation_gwq0h_1mxy7_100",
  "trigger-container": "awsui_trigger-container_gwq0h_1mxy7_112",
  "header": "awsui_header_gwq0h_1mxy7_122",
  "header-container": "awsui_header-container_gwq0h_1mxy7_125",
  "header-navigation": "awsui_header-navigation_gwq0h_1mxy7_132",
  "content": "awsui_content_gwq0h_1mxy7_5",
  "content-default": "awsui_content-default_gwq0h_1mxy7_168",
  "content-footer": "awsui_content-footer_gwq0h_1mxy7_171",
  "content-expanded": "awsui_content-expanded_gwq0h_1mxy7_174",
  "focusable": "awsui_focusable_gwq0h_1mxy7_178"
};
  